import React, { useState } from "react";
import { Col, Container, Row, Modal } from "react-bootstrap";
import Video1 from "../../../images/landing/videos/Ozleasing.mp4";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";
import { Case_ArrowFlutterusa } from "../../../../app-constants";
import BannerForm from "../../components/bannerfrom";

const Slide1 = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <section className="project_lp">
        <Container className="h-100">
          <Row className="h-100">
            <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
              <div className="project_lp_main">
                <div className="project_slider_img">
                  <video autoPlay loop muted controls={false}>
                    <source src={Video1} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
                <div className="project_content">
                  <h6 style={{ color: "#53C7C0" }}>OZ Leasing</h6>
                  <h2>465X Return on Investments</h2>
                  <p>
                    OZ Leasing disrupted car leasing, achieving a 400% increase
                    in daily users, revolutionizing the automotive industry in
                    just 2 years.
                  </p>
                  <div className="btn_main_lp">
                    <Link
                      to=""
                      className="project_btn_lp"
                      aria-label="TekRevol Contact"
                      onClick={handleShow}
                    >
                      Let’s Talk
                    </Link>
                    <span style={{ background: "#53C7C0" }}>
                      {Case_ArrowFlutterusa}
                    </span>
                    <Link
                      to="/case-studies/Oz-Leasing"
                      className="project_btn_lp2"
                      aria-label="TekRevol Contact"
                      style={{ color: "#53C7C0" }}
                      target="_blank"
                    >
                      View Case study
                    </Link>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="landing_lp_popup"
      >
        <div className="modal_forms">
          <BannerForm setShow={setShow} />
        </div>
      </Modal>
    </>
  );
};

export default Slide1;
